module.exports = __webpack_public_path__ + "img/icon_suoxiao.1179547d.svg";